import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { ShiftPlanningDataState } from './shift-planning-data/shift-planning-data.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([ShiftPlanningDataState])],
})
export class ShiftPlanStateModule {}
